import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import EulaModal from './EulaModal';
import PendingMigrationLinksModal from '../migration/PendingMigrationLinksModal';
import migrationService from '../../services/migrationService';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading, needsEulaAcceptance, acceptEula, logout } = useAuth();
  const location = useLocation();
  const [pendingLinks, setPendingLinks] = useState(null);
  const [pendingChecked, setPendingChecked] = useState(false);

  useEffect(() => {
    if (isAuthenticated && !needsEulaAcceptance && !pendingChecked) {
      migrationService.getPendingLinks()
        .then(data => {
          if (data.count > 0) {
            setPendingLinks(data.pending_links);
          }
          setPendingChecked(true);
        })
        .catch(() => {
          setPendingChecked(true);
        });
    }
  }, [isAuthenticated, needsEulaAcceptance, pendingChecked]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-yellow-500"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // Show EULA modal if user needs to accept
  if (needsEulaAcceptance) {
    return (
      <EulaModal
        isOpen={true}
        onAccept={() => acceptEula()}
        onDecline={() => logout()}
      />
    );
  }

  return (
    <>
      {children}
      {pendingLinks && pendingLinks.length > 0 && (
        <PendingMigrationLinksModal
          pendingLinks={pendingLinks}
          onAllResolved={() => setPendingLinks(null)}
        />
      )}
    </>
  );
};

export default ProtectedRoute;
